const ThemeSwitcher = () => {
    const switchTheme = (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
    };

    return (
        <div>
            <button
                onClick={() => switchTheme('tailwindTheme')}
                className="btn m-2"
            >
                tailwindTheme
            </button>
            <button onClick={() => switchTheme('light')} className="btn m-2">
                Light Theme
            </button>
            <button onClick={() => switchTheme('dark')} className="btn m-2">
                Dark Theme
            </button>
            <button onClick={() => switchTheme('cupcake')} className="btn m-2">
                Cupcake Theme
            </button>
            <button
                onClick={() => switchTheme('bumblebee')}
                className="btn m-2"
            >
                bumblebee
            </button>
            <button onClick={() => switchTheme('emerald')} className="btn m-2">
                emerald Theme
            </button>
            <button
                onClick={() => switchTheme('corporate')}
                className="btn m-2"
            >
                corporate Theme
            </button>
            <button
                onClick={() => switchTheme('synthwave')}
                className="btn m-2"
            >
                synthwave Theme
            </button>
            <button onClick={() => switchTheme('retro')} className="btn m-2">
                retro Theme
            </button>
            <button
                onClick={() => switchTheme('cyberpunk')}
                className="btn m-2"
            >
                cyberpunk Theme
            </button>
            <button
                onClick={() => switchTheme('valentine')}
                className="btn m-2"
            >
                valentine Theme
            </button>
            <button
                onClick={() => switchTheme('halloween')}
                className="btn m-2"
            >
                halloween Theme
            </button>
            <button onClick={() => switchTheme('garden')} className="btn m-2">
                garden Theme
            </button>
            <button onClick={() => switchTheme('forest')} className="btn m-2">
                forest Theme
            </button>
            <button onClick={() => switchTheme('aqua')} className="btn m-2">
                aqua Theme
            </button>
            <button onClick={() => switchTheme('lofi')} className="btn m-2">
                lofi Theme
            </button>
            <button onClick={() => switchTheme('pastel')} className="btn m-2">
                pastel Theme
            </button>
            <button onClick={() => switchTheme('fantasy')} className="btn m-2">
                fantasy Theme
            </button>
            <button
                onClick={() => switchTheme('wireframe')}
                className="btn m-2"
            >
                wireframe Theme
            </button>
            <button onClick={() => switchTheme('black')} className="btn m-2">
                black Theme
            </button>
            <button onClick={() => switchTheme('luxury')} className="btn m-2">
                luxury Theme
            </button>
            <button onClick={() => switchTheme('dracula')} className="btn m-2">
                dracula Theme
            </button>
            <button onClick={() => switchTheme('cmyk')} className="btn m-2">
                cmyk Theme
            </button>
            <button onClick={() => switchTheme('autumn')} className="btn m-2">
                autumn Theme
            </button>
            <button onClick={() => switchTheme('business')} className="btn m-2">
                business Theme
            </button>
            <button onClick={() => switchTheme('acid')} className="btn m-2">
                acid Theme
            </button>
            <button onClick={() => switchTheme('lemonade')} className="btn m-2">
                lemonade Theme
            </button>
            <button onClick={() => switchTheme('night')} className="btn m-2">
                night Theme
            </button>
            <button onClick={() => switchTheme('coffee')} className="btn m-2">
                coffee Theme
            </button>
            <button onClick={() => switchTheme('winter')} className="btn m-2">
                winter Theme
            </button>
            <button onClick={() => switchTheme('dim')} className="btn m-2">
                dim Theme
            </button>
            <button onClick={() => switchTheme('nord')} className="btn m-2">
                nord Theme
            </button>
            <button onClick={() => switchTheme('sunset')} className="btn m-2">
                sunset Theme
            </button>
        </div>
    );
};

export default ThemeSwitcher;
